<template>
<div>
  <b-form-textarea
    :value="value"
    @input="handleInput($event.target.value)">
  </b-form-textarea>
</div>
</template>

<script>
import SimpleMDE from 'simplemde';
import helpOptionMenu from '../../editor/menu/options/help';
import opOptionMenu from '../../editor/menu/options/op';
import opuOptionMenu from '../../editor/menu/options/opu';
import pOptionMenu from '../../editor/menu/options/p';
import boldOptionMenu from '../../editor/menu/options/bold';
import italicOptionMenu from '../../editor/menu/options/italic';
import greyOptionMenu from '../../editor/menu/options/grey';
import spanOptionMenu from '../../editor/menu/options/span';
import quotesOptionMenu from '../../editor/menu/options/quotes';
import latexOptionMenu from '../../editor/menu/options/latex';
import euroOptionMenu from '../../editor/menu/options/euro';
import dollarOptionMenu from '../../editor/menu/options/dollar';
import piOptionMenu from '../../editor/menu/options/pi';
// import fractionsBarOptionMenu from '../../editor/menu/options/fractionBar';
import fractionsOptionMenu from '../../editor/menu/options/fraction';
import powerOptionMenu from '../../editor/menu/options/power';
import squareOptionMenu from '../../editor/menu/options/square';
import angleOptionMenu from '../../editor/menu/options/angle';
import decimalOptionMenu from '../../editor/menu/options/decimal';
// import decimalIconOptionMenu from '../../editor/menu/options/decimalIcon';

export default {
  name: 'editor',
  props: {
    value: {
      type: String,
    },
    simpleProblem: {
      type: Boolean,
    },
    formulaProblem: {
      type: Boolean,
    },
    symbols: {
      type: Boolean,
    },
    formats: {
      type: Boolean,
    },
  },
  data() {
    return {
      simplemde: null,
      menu: [
        'preview', 'side-by-side', 'fullscreen',
      ],
    };
  },
  methods: {
    /**
    * @method bindingEvents
    * @description Evento para detectar cambios en el editor
    */
    bindingEvents() {
      this.simplemde.codemirror.on('change', () => {
        const val = this.simplemde.value();
        this.handleInput(val);
      });
    },
    /**
    * @method handleInput
    * @description Setea el valor del componenten simplemde a las propiedad de vue
    */
    handleInput(val) {
      this.$emit('input', val);
    },
    /**
    * @method addSimpleProblem
    * @description Agregar las opciones problemas simple
    */
    addSimpleProblem() {
      // Agrego 3 opciones de op y opu
      for (let i = 1; i <= 3; i += 1) {
        this.menu.push(opOptionMenu(i));
      }

      // Agrego 3 opciones de op y opu
      for (let i = 1; i <= 3; i += 1) {
        this.menu.push(opuOptionMenu(i));
      }
    },
    /**
    * @method addFormulaProblem
    * @description Agregar las opciones problemas formula
    */
    addFormulaProblem() {
      // Agrego la opción p
      this.menu.push(pOptionMenu());

      // Agrego 3 opciones de op y opu
      for (let i = 1; i <= 4; i += 1) {
        this.menu.push(opOptionMenu(i));
      }

      // Agrego 3 opciones de op y opu
      for (let i = 1; i <= 4; i += 1) {
        this.menu.push(opuOptionMenu(i));
      }
    },
    /**
    * @method addSymbols
    * @description Agregar las opciones simbolos
    */
    addSymbols() {
      // Agrego latex
      this.menu.push(latexOptionMenu());

      // Agrego la opción Barra de fracciones
      this.menu.push(fractionsOptionMenu());

      // Agrego la opción potencia
      this.menu.push(powerOptionMenu());

      // Agrego la opción square
      this.menu.push(squareOptionMenu());

      // Agrego la opción decimal
      this.menu.push(decimalOptionMenu());

      // Agrego la opción angulos
      this.menu.push(angleOptionMenu());

      this.menu.push('|');

      // Agrego la opción euro
      this.menu.push(euroOptionMenu());

      // Agrego la opción dollar
      this.menu.push(dollarOptionMenu());

      // Agrego la opción pi
      this.menu.push(piOptionMenu());

      // Agrego la opción fracción
      // this.menu.push(fractionsBarOptionMenu());

      // Agrego la opción decimal
      // this.menu.push(decimalIconOptionMenu());
    },
    /**
    * @method addFormats
    * @description Agregar las opciones de formatos
    */
    addFormats() {
      // Agrego la opción resalte
      this.menu.push(boldOptionMenu());

      // Agrego la opción cursiva
      this.menu.push(italicOptionMenu());

      // Agrego la opción atenuado
      this.menu.push(greyOptionMenu());

      // Agrego la opción span
      this.menu.push(spanOptionMenu());

      // Agrego la opción quotes
      this.menu.push(quotesOptionMenu());
    },
  },
  mounted() {
    const self = this;

    this.menu.push(helpOptionMenu());

    // Agrego las opciones de formatos
    if (this.formats) {
      this.menu.push('|');
      this.menu.push('|');
      this.addFormats();
    }

    // Agrego las opciones de simbolos
    if (this.symbols) {
      this.menu.push('|');
      this.menu.push('|');
      this.addSymbols();
    }

    // Agrego las opciones de problema de formula
    if (this.formulaProblem) {
      this.menu.push('|');
      this.menu.push('|');
      this.addFormulaProblem();
    }

    // Agrego las opciones de problema simples
    if (this.simpleProblem) {
      this.menu.push('|');
      this.menu.push('|');
      this.addSimpleProblem();
    }

    // Instancio el componente
    this.simplemde = new SimpleMDE({
      element: self.$el.firstElementChild,
      toolbar: self.menu,
    });

    // Escucho el evento
    this.bindingEvents();
  },
};
</script>

<style>
  @import '~simplemde/dist/simplemde.min.css';

  .separator + .separator {
    margin-left: 20px !important;
    margin-right: 10px !important;
    color: #cdcdcd !important;
  }

  .qsrtrooticon:after{
    content: url('https://api.iconify.design/fa-solid:square-root.svg?height=12');
  }
  .decimalicon:after{
    content: url('https://api.iconify.design/mdi:decimal-comma-increase.svg?height=22');
    vertical-align: -0.3em;
  }
  .angleicon:after{
    content: url('https://api.iconify.design/mdi:angle-acute.svg?height=22');
    vertical-align: -0.3em;
  }
  .piicon:after{
    content: url('https://api.iconify.design/typcn:pi.svg?height=22');
    vertical-align: -0.3em;
  }
  .fractionicon:after{
    content: url('https://api.iconify.design/bx:bx-pie-chart.svg?height=22');
    vertical-align: -0.3em;
  }
  .powericon:after{
    content: url('https://api.iconify.design/mdi:exponent.svg?height=22');
    vertical-align: -0.3em;
  }
  .latexicon:after{
    content: url('https://api.iconify.design/mdi:math-integral-box.svg?height=22');
    vertical-align: -0.3em;
  }
</style>
